export enum DropdownType {
    SINGLE = 'single',
    MULTIPLE = 'multiple',
    DROPDOWN = 'dropdown',
    SPLIT_DROPDOWN = 'split_dropdown'
}
